import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ReportPreviewManager } from '../../modules/reports/ReportPreviewManager';
// Legacy preview entry — the guided flow lives at /reports/generate. This
// route renders the unlocked picker for any signed-in user.
export const Route = createFileRoute('/reports/sql')({
 beforeLoad:({context})=>{
  if(!context.auth?.user) throw redirect({to:'/login'});
 },
 component:ReportPreviewManager,
});
